import { Avatar, Box, Button, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { MobilePlusButton, PlusButton } from 'Images';

interface IAddClaimButton {
  onClick: () => void;
}

export const AddClaimButton = ({ onClick }: IAddClaimButton) => {
  const isDesktop = useIsDesktop();

  return (
    <Button
      sx={{
        p: isDesktop ? '24px 32px' : '16px 20px',
        gap: '14px',
        border: '1px dashed',
        borderColor: 'primary.shade_200',
        borderRadius: '8px',
        borderWidth: '4px',
        width: '100%',
        maxWidth: isDesktop ? '770px' : undefined,
        position: 'relative',
        height: isDesktop ? 'auto' : '56px',
      }}
      onClick={onClick}
    >
      <Stack
        sx={{
          width: 'calc(100% + 6px)',
          height: 'calc(100% + 6px)',
          position: 'absolute',
          top: '-3px',
          left: '-3px',
          bgcolor: 'white',
          borderRadius: '7px',
          flexDirection: 'row',
          p: isDesktop ? '24px 32px' : '16px 20px',
          gap: '12px',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Avatar
          src={isDesktop ? PlusButton : MobilePlusButton}
          alt=''
          sx={{ width: '24px', height: '24px' }}
        />
        <Typography variant='body6' color='rgba(57, 85, 107, 1)'>
          {Dictionary[DICTIONARY.ExpenseClaim].addExpense}
        </Typography>
      </Stack>
    </Button>
  );
};
